function validateTimeFormat(value) {
  return /^\d{2}:\d{2}:\d{2}$/.test(value);
}

function parseTimeToMinutes(value) {
  const [hours = "0", minutes = "0"] = value.split(":");
  return Number(hours) * 60 + Number(minutes);
}

export function validatePricingTimePayload(payload, options = {}) {
  const { requireId = false } = options;

  if (requireId && !payload?.id) {
    return "El id es obligatorio.";
  }

  if (!payload?.name?.trim()) {
    return "El nombre es obligatorio.";
  }

  if (payload.name.trim().length < 5) {
    return "El nombre debe tener minimo 5 caracteres.";
  }

  if (Number(payload?.dayOfWeek) < 1 || Number(payload?.dayOfWeek) > 7) {
    return "El dia de la semana es invalido.";
  }

  if (!validateTimeFormat(payload?.startTime || "")) {
    return "La hora de inicio debe respetar el formato HH:mm:ss.";
  }

  if (!validateTimeFormat(payload?.endTime || "")) {
    return "La hora de fin debe respetar el formato HH:mm:ss.";
  }

  const startMinutes = parseTimeToMinutes(payload.startTime);
  const endMinutes = parseTimeToMinutes(payload.endTime);

  if (startMinutes >= endMinutes) {
    return "La hora de inicio debe ser menor que la hora de fin.";
  }

  if (endMinutes - startMinutes < 30) {
    return "Debe haber minimo 30 minutos de separacion entre inicio y fin.";
  }

  if (Number(payload?.multiplier) < 1) {
    return "El multiplicador debe ser como minimo 1.0.";
  }

  return null;
}
